module.exports = __webpack_public_path__ + "img/3_123.75b59ebc.png";